var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_vm._t("label",function(){return [(_vm.label)?_c('label',{staticClass:"control-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()]}),_vm._t("default",function(){return [_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.value))])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }